import * as React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
//FB 7111
import StrengthMeter from "../../../components/PasswordStrengthMeter";
import { InputAdornment } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useState } from "react";

// Update log
// FB  6192   02/06/2023  DK  Added page to create username and password during registration
// FB  7111   07/25/2023  DK  Password strength meter and green tick feature
// FB  7085   07/27/2023  GS  Email can be used as username

export default function SecureSignup(props: any) {
  //FB 7111
  const [isCriteriaMet, setIsCriteriaMet] = useState(false);
  const handleChange = (event: { target: { checked: any } }) => {
    if (event.target.checked) {
      props.setTermsAccepted(true);
    } else {
      props.setTermsAccepted(false);
    }
  };

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        <b>Secure Sign Up Details</b>
      </Typography>
      <Typography>
        For full security of your health records, create a secure username and
        password
      </Typography>
      <hr />
      <Grid container spacing={2} flexDirection="column">
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            id="Login"
            name="Login"
            label="Username or Email" //FB 7085
            value={props.patient.Login}
            onChange={props.handleInputChange}
            error={props.errors.Login}
            variant="standard"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            type="password"
            id="PatientPassword"
            name="PatientPassword"
            label="Password"
            value={props.patient.PatientPassword}
            onChange={props.handleInputChange}
            error={props.errors.PatientPassword}
            variant="standard"
            required
            fullWidth
            //FB 7111
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <CheckCircle style={{ color: isCriteriaMet ? "green" : "lightgray" }} />
                </InputAdornment>
              ),
            }}
          />
          {/* FB 7111 */}
          <StrengthMeter password={props.patient.PatientPassword} setIsCriteriaMet={setIsCriteriaMet}/>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            type="password"
            id="PatientPassword2"
            name="PatientPassword2"
            label="Confirm Password"
            value={props.patient.PatientPassword2}
            onChange={props.handleInputChange}
            error={props.errors.PatientPassword2}
            variant="standard"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <h5>Passwords must include:</h5>
          <ul className="list">
            <li>Eight or more characters</li>
            <li>At least one upper and lower case character</li>
            <li>At least one number</li>
            {/* FB 7111 */}
            <li>At least one special character</li>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                color="info"
                name="saveCard"
                value="yes"
                onChange={handleChange}
              />
            }
            label={
              <div>
                <span>Check this box to accept the </span>
                <a href="#">Terms of Use</a>
                <span> acknowledge that you have read our </span>
                <a href="#">Privacy Policy.</a>
              </div>
            }
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
